export default {
  USER_FORM_EMAIL: 'USER_FORM_EMAIL',
  PRO_FORM_EMAIL: 'PRO_FORM_EMAIL',
}
